import React from 'react';
import JobCard from './JobCard';
import LoadingSpinner from '../UI/LoadingSpinner';

/**
 * Component to display a list of job cards
 * @param {Object} props - Component props
 * @param {Array} props.jobs - Array of job objects
 * @param {Array} props.savedJobIds - Array of saved job IDs
 * @param {Function} props.onSaveJob - Function to call when saving a job
 * @param {Function} props.onRemoveJob - Function to call when removing a job
 * @param {boolean} props.loading - Whether the jobs are loading
 * @param {boolean} props.showSaveButtons - Whether to show save buttons on the job cards
 * @param {string|null} props.savingJobId - ID of the job currently being saved/unsaved
 * @returns {JSX.Element} Job list component
 */
const JobList = ({ 
  jobs, 
  savedJobIds = [], 
  onSaveJob, 
  onRemoveJob,
  loading = false,
  showSaveButtons = true,
  savingJobId = null,
  emptyMessage = "No jobs found matching your criteria."
}) => {
  if (loading) {
    return <LoadingSpinner />;
  }
  
  if (!jobs || jobs.length === 0) {
    return <p style={{ textAlign: 'center', padding: '20px' }}>{emptyMessage}</p>;
  }
  
  return (
    <div>
      {jobs.map(job => (
        <JobCard
          key={job.cis_fuss_id}
          job={job}
          isSaved={savedJobIds.some(id => id == job.cis_fuss_id)}
          onSave={onSaveJob}
          onRemove={onRemoveJob}
          showSaveButton={showSaveButtons}
          isSaving={savingJobId === job.cis_fuss_id}
        />
      ))}
    </div>
  );
};

export default JobList;